<section class="content">
  <div class="content-block">
    <div class="block-header">
      <app-breadcrumb [items]="breadcrumbs"></app-breadcrumb>
    </div>

    <mat-accordion class="rx-demo-accordion" [multi]="true">

      <!-- ===================================================== -->
      <!-- DATOS DEL PACIENTE -->
      <!-- ===================================================== -->
      <mat-expansion-panel
        #rxPanel
        [expanded]="panelPacienteOpen"
        data-tour="rx-panel-paciente"
        class="rx-panel"
      >
        <mat-expansion-panel-header>
          <mat-panel-title>
            DATOS DEL PACIENTE
            @if (patientSelected) {
              <span class="rx-panel-selected">: {{ selectedPatientName }}</span>
            }
          </mat-panel-title>
        </mat-expansion-panel-header>

        <!-- ESTADO BÚSQUEDA -->
        @if (!patientSelected) {
          <div class="row">
            <div class="col-lg-12">
              <mat-form-field appearance="outline" class="example-full-width">
                <mat-label>INGRESE EL NOMBRE DEL PACIENTE</mat-label>
                <input
                  matInput
                  type="text"
                  name="patientSearch"
                  appUppercaseNoAccent
                  autocomplete="off"
                  [(ngModel)]="patientSearch"
                  data-tour="rx-patient-search"
                  (focus)="openPatientAutocomplete()"
                />
              </mat-form-field>

              @if (showPatientAutocomplete) {
                <div class="rx-demo-autocomplete rx-demo-autocomplete--patient" data-tour="rx-patient-results">
                  @for (option of patientOptions; track option.id) {
                    <div class="rx-demo-option" (click)="selectPatient()">
                      {{ option.fullName }}
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        }

        <!-- ESTADO PACIENTE CARGADO -->
        @if (patientSelected) {
          <div class="rx-summary-card">
            <h3 class="rx-summary-title">RESUMEN CLINICO DEL PACIENTE</h3>
            <p class="rx-summary-subtitle">
              REVISA ANTECEDENTES Y MEDICACION ACTIVA ANTES DE PRESCRIBIR.
            </p>

            <div class="row">
              <div class="col-lg-6 col-md-6 col-sm-12">
                <div class="rx-summary-box">
                  <div class="rx-summary-box-title">
                    <mat-icon>medical_information</mat-icon>
                    ANTECEDENTES CRONICOS
                  </div>

                  <div class="rx-summary-empty">
                    <mat-icon>info</mat-icon>
                    NO HAY ANTECEDENTES CRONICOS REGISTRADOS.
                  </div>
                </div>
              </div>

              <div class="col-lg-6 col-md-6 col-sm-12">
                <div class="rx-summary-box">
                  <div class="rx-summary-box-title">
                    <mat-icon>medication</mat-icon>
                    MEDICAMENTOS ACTIVOS
                  </div>

                  <div class="rx-summary-empty">
                    <mat-icon>info</mat-icon>
                    NO HAY MEDICAMENTOS ACTIVOS REGISTRADOS.
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </mat-expansion-panel>

      <br />

      <!-- ===================================================== -->
      <!-- DATOS DE CONSULTA -->
      <!-- ===================================================== -->
      @if (patientSelected) {
        <mat-expansion-panel
          #rxPanel
          [expanded]="panelConsultaOpen"
          data-tour="rx-panel-consulta"
          class="rx-panel"
        >
          <mat-expansion-panel-header>
            <mat-panel-title>DATOS DE CONSULTA</mat-panel-title>
          </mat-expansion-panel-header>

          <div class="header">
            <p class="rx-section-title">PERFIL DE PACIENTE</p>
          </div>

          <mat-divider></mat-divider>
          <br />

          <div class="row">
            <div class="col-lg-3 col-md-3 col-sm-12">
              <mat-form-field appearance="outline" class="example-full-width">
                <mat-label>GENERO*</mat-label>
                <mat-select [(ngModel)]="consultationData.genero" data-tour="rx-gender">
                  <mat-option value="FEMENINO">FEMENINO</mat-option>
                  <mat-option value="MASCULINO">MASCULINO</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="col-lg-3 col-md-3 col-sm-12">
              <mat-form-field appearance="outline" class="example-full-width">
                <mat-label>EDAD</mat-label>
                <input matInput [(ngModel)]="consultationData.edad" />
              </mat-form-field>
            </div>

            <div class="col-lg-3 col-md-3 col-sm-12">
              <mat-form-field appearance="outline" class="example-full-width">
                <mat-label>PESO*</mat-label>
                <input
                  matInput
                  [(ngModel)]="consultationData.peso"
                  data-tour="rx-weight"
                />
                <span matSuffix>KG &nbsp;</span>
              </mat-form-field>
            </div>

            <div class="col-lg-3 col-md-3 col-sm-12">
              <mat-form-field appearance="outline" class="example-full-width">
                <mat-label>ALTURA*</mat-label>
                <input
                  matInput
                  [(ngModel)]="consultationData.altura"
                  data-tour="rx-height"
                />
                <span matSuffix>CM &nbsp;</span>
              </mat-form-field>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-3 col-md-3 col-sm-12">
              <mat-form-field appearance="outline" class="example-full-width">
                <mat-label>ACLARAMIENTO CREATININA</mat-label>
                <input matInput [(ngModel)]="consultationData.creatinina" />
                <span matSuffix>ML/MIN &nbsp;</span>
              </mat-form-field>
            </div>

            @if (showWeeksInput) {
              <div class="col-lg-3 col-md-3 col-sm-12">
                <mat-form-field appearance="outline" class="example-full-width">
                  <mat-label>SEMANAS</mat-label>
                  <input matInput [(ngModel)]="consultationData.semanas" />
                </mat-form-field>
              </div>
            }

            <div class="col-lg-6 col-md-6 col-sm-12 checkbox-container">
              <mat-checkbox
                [(ngModel)]="embarazo"
                (change)="toggleWeeksInput()"
              >
                EMBARAZO
              </mat-checkbox>

              <mat-checkbox
                [(ngModel)]="lactancia"
                (change)="toggleWeeksInput()"
              >
                LACTANCIA
              </mat-checkbox>
            </div>
          </div>
        </mat-expansion-panel>

        <br />
      }

      <!-- ===================================================== -->
      <!-- DIAGNOSTICO -->
      <!-- ===================================================== -->
      @if (patientSelected) {
        <mat-expansion-panel
          #rxPanel
          [expanded]="panelDiagnosticoOpen"
          data-tour="rx-panel-diagnostico"
          class="rx-panel"
        >
          <mat-expansion-panel-header>
            <mat-panel-title>DIAGNOSTICO</mat-panel-title>
          </mat-expansion-panel-header>

          <div class="row mt-3">
            <div class="col-lg-6 col-md-6 col-sm-12">
              <mat-form-field appearance="outline" class="example-full-width">
                <mat-label>BUSCAR PATOLOGIA</mat-label>
                <input
                  matInput
                  [(ngModel)]="diagnosisSearch"
                  data-tour="rx-search-patologias"
                  (focus)="openDiagnosisAutocomplete()"
                />
              </mat-form-field>

              @if (showDiagnosisAutocomplete) {
                <div class="rx-demo-autocomplete">
                  <div class="rx-demo-option">
                    NEUMONIA DEBIDA A VARICELA
                  </div>
                </div>
              }
            </div>

            <div class="col-lg-6 col-md-6 col-sm-12">
              <mat-form-field appearance="outline" class="example-full-width">
                <mat-label>BUSCAR ALERGIA</mat-label>
                <input
                  matInput
                  [(ngModel)]="allergySearch"
                  data-tour="rx-search-alergias"
                />
              </mat-form-field>

              <div class="rx-inline-checks">
                <mat-checkbox checked>ALERGIA</mat-checkbox>
                <mat-checkbox checked>MOLECULA</mat-checkbox>
              </div>
            </div>
          </div>

          @if (showDiagnosisTable) {
            <div class="rx-diagnosis-table-wrap">
              <table class="rx-simple-table">
                <thead>
                <tr>
                  <th>TIPO</th>
                  <th>NOMBRE</th>
                  <th data-tour="rx-col-cronico">CRONICO?</th>
                  <th>CODIGO</th>
                  <th>ACCIONES</th>
                </tr>
                </thead>
                <tbody>
                  @for (row of diagnosisRows; track row.codigo) {
                    <tr>
                      <td>{{ row.tipo }}</td>
                      <td>{{ row.nombre }}</td>
                      <td data-tour="rx-cronico-checkbox">
                        <mat-checkbox [checked]="row.cronico"></mat-checkbox>
                      </td>
                      <td>{{ row.codigo }}</td>
                      <td>
                        <button mat-icon-button type="button" class="tbl-action-btn">
                          <mat-icon class="rx-icon-danger">delete_outline</mat-icon>
                        </button>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          }
        </mat-expansion-panel>

        <br />
      }

      <!-- ===================================================== -->
      <!-- MEDICAMENTOS -->
      <!-- ===================================================== -->
      @if (patientSelected) {
        <mat-expansion-panel
          #rxPanel
          [expanded]="panelMedicamentosOpen"
          data-tour="rx-panel-meds"
          class="rx-panel"
        >
          <mat-expansion-panel-header>
            <mat-panel-title>MEDICAMENTOS</mat-panel-title>
          </mat-expansion-panel-header>

          <div class="row mt-3">
            <div class="col-lg-6 col-md-6 col-sm-12">
              <mat-form-field appearance="outline" class="example-full-width">
                <mat-label>BUSCAR MEDICAMENTOS</mat-label>
                <input
                  matInput
                  [(ngModel)]="medicationSearch"
                  data-tour="rx-search-medicamentos"
                  (focus)="openMedicationAutocomplete()"
                />
              </mat-form-field>

              @if (showMedicationAutocomplete) {
                <div class="rx-demo-autocomplete rx-demo-autocomplete--meds" data-tour="rx-med-results">
                  @for (item of medicationAutocompleteOptions; track $index) {
                    <div class="rx-demo-option" (click)="openPosologyModal()">
                      {{ item }}
                    </div>
                  }
                </div>
              }
            </div>
          </div>

          @if (showMedicationTable) {
            <div class="rx-meds-table-card">
              @for (row of medicationRows; track row.medicamento) {
                <div class="rx-med-row">
                  <div class="rx-med-row-top">
                    <div class="rx-med-col rx-med-col--type">
                      <span class="rx-med-label">TIPO</span>
                      <span class="rx-med-pill">{{ row.tipo }}</span>
                    </div>

                    <div class="rx-med-col rx-med-col--drug">
                      <span class="rx-med-label">MEDICAMENTO</span>
                      <span class="rx-med-name">{{ row.medicamento }}</span>
                    </div>
                  </div>

                  <div class="rx-med-divider"></div>

                  <div class="rx-med-row-bottom">
                    <div class="rx-med-col">
                      <span class="rx-med-label">DOSIS</span>
                      <span class="rx-med-value">{{ row.dosis }}</span>
                    </div>

                    <div class="rx-med-col">
                      <span class="rx-med-label">FRECUENCIA</span>
                      <span class="rx-med-value">{{ row.frecuencia }}</span>
                    </div>

                    <div class="rx-med-col">
                      <span class="rx-med-label">DURACION</span>
                      <span class="rx-med-value">{{ row.duracion }}</span>
                    </div>

                    <div class="rx-med-col">
                      <span class="rx-med-label">VIA</span>
                      <span class="rx-med-value">{{ row.via }}</span>
                    </div>

                    <div class="rx-med-col">
                      <span class="rx-med-label">MOTIVO</span>
                      <span class="rx-med-value">{{ row.motivo }}</span>
                    </div>

                    <div class="rx-med-col rx-med-col--wide">
                      <span class="rx-med-label">INDICACIONES</span>
                      <span class="rx-med-value">{{ row.indicaciones }}</span>
                    </div>

                    <div class="rx-med-col rx-med-col--actions">
                      <span class="rx-med-label">ACCIONES</span>

                      <div class="rx-actions">
                        <button
                          mat-icon-button
                          type="button"
                          matTooltip="VER DOCUMENTOS VIDAL"
                          data-tour="rx-action-docs"
                        >
                          <mat-icon class="rx-icon-primary">description</mat-icon>
                        </button>

                        <button
                          mat-icon-button
                          type="button"
                          matTooltip="OCULTAR MEDICAMENTO"
                          data-tour="rx-action-hide"
                        >
                          <mat-icon class="rx-icon-dark">visibility</mat-icon>
                        </button>

                        <button
                          mat-icon-button
                          type="button"
                          data-tour="rx-edit-line"
                          matTooltip="EDITAR POSOLOGIA"
                          (click)="openPosologyModal()"
                        >
                          <mat-icon class="rx-icon-edit">edit</mat-icon>
                        </button>

                        <button
                          mat-icon-button
                          type="button"
                          matTooltip="ELIMINAR"
                          data-tour="rx-action-delete-med"
                          (click)="deleteMedicationDemo()"
                        >
                          <mat-icon class="rx-icon-danger">delete_outline</mat-icon>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>
          }
        </mat-expansion-panel>

        <br />
      }

      <!-- ===================================================== -->
      <!-- ALERTAS -->
      <!-- ===================================================== -->
      @if (patientSelected) {
        <mat-expansion-panel
          #rxPanel
          [expanded]="panelAlertasOpen"
          class="rx-panel"
        >
          <mat-expansion-panel-header>
            <mat-panel-title>ALERTAS</mat-panel-title>
          </mat-expansion-panel-header>

          <div class="rx-alerts-wrap">
            <div class="rx-alerts-status">SIN ALERTAS CRITICAS</div>

            <button type="button" class="rx-alert-btn rx-alert-btn--gray">
              <mat-icon>visibility</mat-icon>
              VER ADVERTENCIAS CRITICAS
            </button>

            <button type="button" class="rx-alert-btn rx-alert-btn--outline">
              <mat-icon>visibility</mat-icon>
              <span class="rx-vidal-brand">VIDAL GROUP</span>
              VER ANALISIS VADEMECUM
            </button>
          </div>
        </mat-expansion-panel>

        <br />

        <div class="rx-save-wrap">
          <button
            mat-raised-button
            color="primary"
            type="button"
            class="rx-save-btn"
            data-tour="rx-save"
          >
            GUARDAR RECETA
          </button>
        </div>
      }
    </mat-accordion>
  </div>
</section>

<!-- ===================================================== -->
<!-- MODAL POSOLOGÍA DEMO -->
<!-- ===================================================== -->
@if (showPosologyModal) {
  <div class="rx-modal-backdrop">
    <div class="rx-modal-card" data-tour="rx-line-modal">
      <button
        type="button"
        class="rx-modal-close"
        (click)="closePosologyModal()"
        aria-label="Cerrar modal"
      >
        ×
      </button>

      <h2 class="rx-modal-title">POSOLOGIA DEL MEDICAMENTO</h2>

      <div class="rx-modal-drug-label">MEDICAMENTO:</div>
      <div class="rx-modal-drug-name">
        {{ posologia.medicamento }}
      </div>

      <div class="row mt-3">
        <div class="col-lg-3 col-md-6 col-sm-12">
          <mat-form-field appearance="outline" class="example-full-width">
            <mat-label>CANTIDAD:*</mat-label>
            <input matInput [(ngModel)]="posologia.cantidad" data-tour="rx-line-dose" />
          </mat-form-field>
        </div>

        <div class="col-lg-3 col-md-6 col-sm-12">
          <mat-form-field appearance="outline" class="example-full-width">
            <mat-label>UNIDAD:</mat-label>
            <mat-select [(ngModel)]="posologia.unidad" data-tour="rx-line-unit">
              <mat-option value="COMPRIMIDO">COMPRIMIDO</mat-option>
              <mat-option value="TABLETA">TABLETA</mat-option>
              <mat-option value="ML">ML</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-lg-3 col-md-6 col-sm-12">
          <mat-form-field appearance="outline" class="example-full-width">
            <mat-label>CADA</mat-label>
            <input matInput [(ngModel)]="posologia.cada" data-tour="rx-line-each" />
          </mat-form-field>
        </div>

        <div class="col-lg-3 col-md-6 col-sm-12">
          <mat-form-field appearance="outline" class="example-full-width">
            <mat-label>FRECUENCIA*</mat-label>
            <mat-select [(ngModel)]="posologia.frecuencia" data-tour="rx-line-freq-type">
              <mat-option value="HORA(S)">HORA(S)</mat-option>
              <mat-option value="DIA(S)">DIA(S)</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-3 col-md-6 col-sm-12">
          <mat-form-field appearance="outline" class="example-full-width">
            <mat-label>DURACION:*</mat-label>
            <input matInput [(ngModel)]="posologia.duracion" data-tour="rx-line-duration" />
          </mat-form-field>
        </div>

        <div class="col-lg-3 col-md-6 col-sm-12">
          <mat-form-field appearance="outline" class="example-full-width">
            <mat-label>PERIODO:</mat-label>
            <mat-select [(ngModel)]="posologia.periodo" data-tour="rx-line-duration-type">
              <mat-option value="DIA(S)">DIA(S)</mat-option>
              <mat-option value="SEMANA(S)">SEMANA(S)</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-lg-3 col-md-6 col-sm-12">
          <mat-form-field appearance="outline" class="example-full-width">
            <mat-label>VIA:</mat-label>
            <mat-select [(ngModel)]="posologia.via" data-tour="rx-line-route">
              <mat-option value="ORAL">ORAL</mat-option>
              <mat-option value="SUBLINGUAL">SUBLINGUAL</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-lg-3 col-md-6 col-sm-12">
          <mat-form-field appearance="outline" class="example-full-width">
            <mat-label>MOTIVO DE USO:</mat-label>
            <mat-select [(ngModel)]="posologia.motivo" data-tour="rx-line-reason">
              <mat-option value="FIEBRE">FIEBRE</mat-option>
              <mat-option value="DOLOR">DOLOR</mat-option>
            </mat-select>
          </mat-form-field>
          <small class="rx-optional-note">OPCIONAL</small>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-12">
          <mat-form-field appearance="outline" class="example-full-width">
            <mat-label>INDICACIONES DE USO DEL MEDICAMENTO:</mat-label>
            <textarea
              matInput
              rows="3"
              [(ngModel)]="posologia.indicaciones"
              data-tour="rx-line-indication"
            ></textarea>
          </mat-form-field>
          <small class="rx-optional-note">OPCIONAL</small>
        </div>
      </div>

      <div class="rx-modal-actions">
        <button
          mat-raised-button
          color="primary"
          type="button"
          class="rx-btn-save"
          data-tour="rx-line-save"
          (click)="savePosologyDemo()"
        >
          GUARDAR
        </button>

        <button
          mat-raised-button
          color="warn"
          type="button"
          class="rx-btn-cancel"
          (click)="closePosologyModal()"
        >
          CANCELAR
        </button>
      </div>
    </div>
  </div>
}
